module.exports = __webpack_public_path__ + "static/media/nature-business-d.a6dc130c.webp";